<template>
  <component :is="component" />
</template>

<script>
import highenMaterialPLanCheck from '../components/highenMaterialPLanCheck.vue'
import highendMaterialPlan from '../highendMaterialPlan.vue'
export default {
  components: {
    highenMaterialPLanCheck,
    highendMaterialPlan
  },
  data() {
    return {
      component: 'highenMaterialPLanCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'highenMaterialPLanCheck' : 'highendMaterialPlan'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/material-plan-manage/check/highendMaterialPlanCheck.vue